import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import appConstants from "../utils/config";

type ThemeType = "dark-default" | "golain" | "none";

interface IThemeState {
  theme: ThemeType;
  setTheme: (theme: ThemeType) => void;
}

const useThemeStore = create<IThemeState>()(
  persist(
    devtools(
      (set) => ({
        theme: "dark-default",
        setTheme: (theme) =>
          set(
            (state) => ({ ...state, theme }),
            false,
            "theme/setTheme"
          )
      }),
      { name: "theme", serialize: { options: true } }
    ),
    {
      name: "theme",
      storage: createJSONStorage(() => appConstants.keys.storage)
    }
  )
);

export default useThemeStore;
